  <div class="view-wrapper-register-merchant">
    
    <dx-load-panel
      container=".view-wrapper-scroll"
      [visible]="isLoading"
      [showPane]="false"
      [position]="{ of: 'user-profile' }"
    >
    </dx-load-panel>
    <dx-scroll-view class="view-wrapper-scroll" (onScroll)="scroll($event)">
      <div *ngIf="!isLoading" class="cards-container">
        <div class="panel">
          <div class="title-text panel-header">
            <!-- Some Text Here -->
          </div>
          <div class="form-container">
            <ng-content select="[top-item]"></ng-content>
              
            <app-rich-form #contactDetailsFormComponent
              class="profile-card basic-info-card"
              
              [colCount]="1"
              [cardData]="contactData"
              [formwidth]="350"
              [items]="formUiWidgets"
              (dataChanged)="dataChanged($event)"
            >
           </app-rich-form>


          </div>
        </div>
      </div>
    </dx-scroll-view>
  </div>
